// extracted by mini-css-extract-plugin
module.exports = {"label":"_02712f2b3b--label--MJZMh"};